import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift, Check, Sparkles, Package, Flame, TrendingUp } from 'lucide-react';
const bonuses = [{
  title: 'Overthinking Detox',
  description: 'Break mental loops in 7 days. Stop the spiral before it starts with practical, daily exercises.',
  image: 'https://cdn.magicpatterns.com/uploads/4A6Rum7kUQhYEYWpeXzJ7o/ChatGPT_Image_Feb_15,_2026,_11_11_55_PM.png',
  price: 19.97
}, {
  title: 'Social Anxiety Confidence Builder',
  description: 'Calm your nervous system in social situations. Practical tools to feel safe around others.',
  image: 'https://cdn.magicpatterns.com/uploads/9s8W1AvEpwRjdJbqbn411G/ChatGPT_Image_Feb_15,_2026,_11_10_03_PM.png',
  price: 19.97
}, {
  title: 'High-Performance Calm Toolkit',
  description: 'Stay sharp under pressure without burning out. Master your stress response for clarity and precision.',
  image: 'https://cdn.magicpatterns.com/uploads/hw4nNPY4gX6u787ShCfJi7/ChatGPT_Image_Feb_15,_2026,_11_08_06_PM.png',
  price: 19.97
}, {
  title: 'Workplace Anxiety Stabilizer',
  description: 'A practical framework to stay regulated under pressure and perform with confidence at work.',
  image: 'https://cdn.magicpatterns.com/uploads/u8xG33StCoCffAwquTxR9M/ChatGPT_Image_Feb_15,_2026,_11_05_04_PM.png',
  price: 19.97
}];
const totalBonusValue = bonuses.reduce((sum, b) => sum + b.price, 0);
const guidePrice = 47;
const grandTotal = totalBonusValue + guidePrice;
const promoPrice = 9.97;
export function BonusesSection() {
  return <section className="py-20 bg-white overflow-hidden border-t border-[#E0E7FF]" data-id="element-10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block mb-4" data-id="element-13">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#818CF8] text-white text-sm font-bold shadow-sm" data-id="element-14">
              <Gift className="w-4 h-4" data-id="element-15" />
              FREE with your purchase!
            </span>
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E1B4B] mb-4" data-id="element-16">
            4 Bonus Guides{' '}
            <span className="relative inline-block" data-id="element-17">
              <span className="relative z-10" data-id="element-18">Included</span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-[#FDE68A]/60 -z-0 rounded-sm" data-id="element-19"></span>
            </span>
          </h2>
          <p className="text-[#44403C] max-w-md mx-auto" data-id="element-20">
            Targeted systems for the{' '}
            <span className="font-semibold text-[#1E1B4B]" data-id="element-21">
              most common anxiety triggers.
            </span>
          </p>
        </div>

        {/* Bonus Cards with Images */}
        <div className="max-w-6xl mx-auto mb-16" data-id="element-22">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-23">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#FAFAFF] rounded-2xl overflow-hidden border border-[#E0E7FF] shadow-sm group" data-id="element-24">
                {/* Book Image */}
                <div className="relative p-4 bg-gradient-to-b from-[#EEF2FF] to-[#FAFAFF]" data-id="element-25">
                  <div className="absolute top-3 right-3 bg-[#818CF8] text-white text-xs font-bold px-2 py-1 rounded-full shadow-sm" data-id="element-26">
                    FREE
                  </div>
                  <img src={bonus.image} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-48 object-contain drop-shadow-xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-27" />
                </div>

                {/* Content */}
                <div className="p-5" data-id="element-28">
                  <div className="flex items-start justify-between gap-2 mb-3" data-id="element-29">
                    <h3 className="font-bold text-[#1E1B4B] text-sm leading-tight" data-id="element-30">
                      {bonus.title}
                    </h3>
                    <span className="flex-shrink-0 text-sm font-bold text-[#818CF8] line-through opacity-60" data-id="element-31">
                      ${bonus.price.toFixed(2)}
                    </span>
                  </div>
                  <p className="text-[#44403C] text-xs leading-relaxed" data-id="element-32">
                    {bonus.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Total Value Box */}
        <div className="max-w-4xl mx-auto" data-id="element-33">
          {/* All Books Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-8" data-id="element-34">
            <div className="relative rounded-2xl overflow-hidden shadow-xl ring-4 ring-white" data-id="element-35">
              <img src="https://cdn.magicpatterns.com/uploads/uuriDZ9ijVhPw4NuJmNkRM/ChatGPT_Image_Feb_15,_2026,_11_29_25_PM.png" alt="Complete 7 Signals Reset™ bundle — Main guide plus 4 bonus guides" loading="lazy" decoding="async" className="w-full h-auto object-cover" data-id="element-36" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1E1B4B]/70 via-transparent to-transparent flex items-end p-6 md:p-8" data-id="element-37">
                <div data-id="element-38">
                  <p className="text-white text-lg md:text-xl font-bold mb-1 flex items-center gap-2" data-id="element-39">
                    <Package className="w-5 h-5" data-id="element-40" /> Everything you get today for
                    just $9.97
                  </p>
                  <p className="text-white/80 text-sm" data-id="element-41">
                    Main guide + 4 bonus guides — valued at $126.88.{' '}
                    <span className="text-[#FDE68A] font-semibold" data-id="element-42">
                      You save over 92%.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-r from-[#312E81] to-[#4338CA] rounded-2xl p-6 md:p-8 text-white text-center shadow-xl" data-id="element-43">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-44">
              <Sparkles className="w-5 h-5" data-id="element-45" />
              <span className="text-sm font-semibold uppercase tracking-wider opacity-90" data-id="element-46">
                Value Summary
              </span>
              <Sparkles className="w-5 h-5" data-id="element-47" />
            </div>

            {/* Price breakdown */}
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-6 max-w-sm mx-auto" data-id="element-48">
              <div className="flex justify-between items-center mb-2 text-sm" data-id="element-49">
                <span className="opacity-80" data-id="element-50">
                  7 Signals Reset™ (Main Guide)
                </span>
                <span className="font-semibold" data-id="element-51">${guidePrice.toFixed(2)}</span>
              </div>
              <div className="flex justify-between items-center mb-2 text-sm" data-id="element-52">
                <span className="opacity-80" data-id="element-53">4 Bonus Guides</span>
                <span className="font-semibold" data-id="element-54">
                  ${totalBonusValue.toFixed(2)}
                </span>
              </div>
              <div className="border-t border-white/20 my-3" data-id="element-55"></div>
              <div className="flex justify-between items-center text-lg" data-id="element-56">
                <span className="font-bold" data-id="element-57">Total Value</span>
                <span className="font-bold line-through opacity-60" data-id="element-58">
                  ${grandTotal.toFixed(2)}
                </span>
              </div>
            </div>

            {/* Promo price */}
            <div className="mb-4" data-id="element-59">
              <p className="text-white/80 text-sm mb-2 flex items-center justify-center gap-1.5" data-id="element-60">
                <Flame className="w-4 h-4 text-[#FCA5A5]" data-id="element-61" /> Launch price —{' '}
                <span className="text-[#FCA5A5] font-bold" data-id="element-62">
                  price increases soon
                </span>
              </p>
              <div className="flex items-center justify-center gap-3" data-id="element-63">
                <span className="text-2xl line-through opacity-50" data-id="element-64">
                  ${grandTotal.toFixed(2)}
                </span>
                <span className="text-5xl md:text-6xl font-bold text-[#FDE68A]" data-id="element-65">
                  ${promoPrice}
                </span>
              </div>
              <p className="text-[#FDE68A] text-sm font-semibold mt-2" data-id="element-66">
                You save ${(grandTotal - promoPrice).toFixed(2)}! (92% off)
              </p>
            </div>

            <p className="text-white/70 text-xs max-w-md mx-auto" data-id="element-67">
              Main guide + 4 bonus guides valued at $
              {totalBonusValue.toFixed(2)} included FREE
            </p>
          </motion.div>

          <div className="mt-8 text-center" data-id="element-68">
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-[#4338CA] text-white text-sm font-bold shadow-lg" data-id="element-69">
              <Check className="w-4 h-4 mr-2" data-id="element-70" />
              Ready to start today
            </span>
          </div>
        </div>
      </div>
    </section>;
}